__turbopack_context__.v({
  "content": "DailyProblem-module-scss-module__kAGyNG__content",
});
